import React, { useEffect, useState } from "react";
import { Table, Spin, message, Button, Tooltip, Popconfirm, Typography } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import ApiService from "../Components/apiService";
import { BASE_URL } from "../Components/Constant";
import { useSelector } from "react-redux";

const { Title } = Typography;

const PipelineTable = () => {
  const [pipelines, setPipelines] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageSize, setPageSize] = useState(10);

  const navigate = useNavigate();
  const security = useSelector((state) => state.data.items[0]);

  // Fetch pipelines
  const fetchPipelines = async () => {
    setLoading(true);

    const apiService = new ApiService(`${BASE_URL}/pipeline`, {
      "Content-Type": "application/json",
    }, "GET");

    try {
      const response = await apiService.makeCall();
      setPipelines(response || []);
    } catch (err) {
      console.error(err);
      message.error("Failed to fetch pipelines");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPipelines();
  }, []);

  // Delete pipeline
  const deletePipeline = async (record) => {
    // if (security?.system_settings?.objects?.delete === false) {
    //   message.error("You don't have permission to delete");
    //   return;
    // }

    setLoading(true);

    const apiService = new ApiService(
      `${BASE_URL}/pipeline/${record._id}`,
      {},
      "DELETE"
    );

    try {
      await apiService.makeCall();
      message.success("Pipeline deleted successfully");
      fetchPipelines();
    } catch (error) {
      console.error("Delete failed", error);
      message.error("Failed to delete pipeline");
    } finally {
      setLoading(false);
    }
  };

  // Edit
  const handleEdit = (record) => {
    // if (security?.system_settings?.objects?.edit === false) {
    //   message.error("You don't have permission to edit");
    //   return;
    // }

    navigate(`/setup/PipelineBuilder/${record._id}`);
  };

  // New pipeline
  const handleCreate = () => {
    // if (security?.system_settings?.objects?.create === false) {
    //   message.error("You don't have permission to create");
    //   return;
    // }

    navigate("/setup/PipelineBuilder");
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: "API Name",
      dataIndex: "apiname",
      sorter: (a, b) => a.apiname.localeCompare(b.apiname),
    },
    {
      title: "Description",
      dataIndex: "description",
      sorter: (a, b) => (a.description || "").localeCompare(b.description || ""),
    },
    {
      title: "Actions",
      key: "actions",
      width: 120,
      render: (_, record) => (
        <>
          <Tooltip title="Edit">
            <EditOutlined
              onClick={() => handleEdit(record)}
              style={{ marginRight: 10, cursor: "pointer", fontSize: 13 }}
            />
          </Tooltip>

          <Tooltip title="Delete">
            <Popconfirm
              title="Are you sure you want to delete this pipeline?"
              okText="Yes"
              cancelText="No"
              onConfirm={() => deletePipeline(record)}
            >
              <DeleteOutlined
                style={{ color: "red", cursor: "pointer", fontSize: 13 }}
              />
            </Popconfirm>
          </Tooltip>
        </>
      ),
    },
  ];

  return (
    <div>
      <Spin size="large" spinning={loading}>
        <Table
          title={() => (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Title level={4}>Pipelines</Title>
              <Button type="primary" onClick={handleCreate}>
                New Pipeline
              </Button>
            </div>
          )}
          style={{ marginTop: 10 }}
          dataSource={pipelines}
          columns={columns}
          rowKey="_id"
          scroll={{ x: "max-content", y: 550 }}
          pagination={{
            pageSize,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "50", "100"],
            onChange: (_, size) => setPageSize(size),
          }}
        />
      </Spin>
    </div>
  );
};

export default PipelineTable;
